goog.provide("shadow.js.shim.module$src$svg$wpp$content$iframe_svg$default");
shadow.js.shim.module$src$svg$wpp$content$iframe_svg$default = shadow.js.shim.module$src$svg$wpp$content$iframe_svg.default;
